export default "../../src/img/google-play-swedish.png";